function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M75.8261 23.1818v-2H8.1739v41.6364h67.6522V23.1818zM8 63V21h68v42H8z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 4
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M15.5 28h15v4h-15zM34.5 28h15v4h-15zM53.5 28h15v4h-15zM15.5 36h15v4h-15zM34.5 36h15v4h-15zM53.5 36h15v4h-15zM15.5 44h15v4h-15zM34.5 44h15v4h-15zM53.5 44h15v4h-15zM15.5 52h15v4h-15zM34.5 52h15v4h-15zM53.5 52h15v4h-15z"
});
var SvgTable = function SvgTable(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/table.005c4798.svg";
export { ForwardRef as ReactComponent };